import {
    ADD_FAVOURITE_FEATURE_SUCCESS,
    FETCH_ALL_FEATURE_SUCCESS,
    FETCH_FEATURE_SUCCESS,
    FILTER_FEATURE,
    GET_ALL_FEATURE,
    GET_UNSELECTED_ALL_FEATURE,
    HANDLE_FEATURE_REQUEST_CLOSE,
    HIDE_FEATURE_LOADER,
    SHOW_FEATURE_LOADER,
    ON_ADD_FEATURE,
    ON_ALL_FEATURE_SELECT,
    ON_FEATURE_CLOSE,
    ON_FEATURE_SELECT,
    ON_DELETE_FEATURE_SUCCESS,
    ON_FILTER_SELECTED_FEATURE,
    ON_FILTER_FEATURE_OPTION_SELECT,
    ON_SAVE_FEATURE_SUCCESS,
    ON_TOGGLE_FEATURE_DRAWER,
    SHOW_FEATURE_MESSAGE,
    UPDATE_SEARCH_FEATURE,
    CLEAR_SESSION,
    SET_FEATURE,
    ON_EDIT_FEATURE,
    ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS,
    ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All features';
export const STARRED_FILTER = 'Starred features';
export const SUCCESSFUL_UPDATE = 'Feature Updated Successfully';
export const SUCCESSFUL_FILTER = 'Feature Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Feature Deleted Successfully';
export const REMOVED_AS_STAR = 'Feature removed as star';
export const MARKED_AS_STAR = 'Feature marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No features found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allFeature: [],
    featureList: [],
    selectedFeature: null,
    selectedFeatures: 0,
    addFeatureState: false,
    searchFeature: '',
    editFeatureState: false,
    dependencyList: [],
    selectedDependencies: 0,
    dependency: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150',
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedFeature: null,
            };
        }
        case ON_FETCH_SELECT_FEATURE_DEPENDENCIES_SUCCESS: {
            return {
                ...state,
                dependencyList: action?.payload,
                loader: false,
            };
        }
        case ON_FEATURE_DEPENDENCY_UPDATE_SUCCESS: {
            const updatedSelectedFeature = action?.payload?.find((updated) => updated?.id === state?.selectedFeature?.id);
            return {
                ...state,
                loader: false,
                selectedFeature: updatedSelectedFeature,
                featureList: action?.payload,
                allFeature: action?.payload,
            };
        }
        case SET_FEATURE: {
            const features = state.allFeature.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedFeature: features?.length > 0 ? features[0] : [],
            };
        }
        case ADD_FAVOURITE_FEATURE_SUCCESS: {
            const allUpdated = state.allFeature.map((entry) =>
                entry?.id === action?.payload?.id
                    ? {
                          ...entry,
                          starred: !action?.payload?.starred,
                      }
                    : entry
            );
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                featureList: listUpdated,
                allFeature: allUpdated,
            };
        }
        case FETCH_FEATURE_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedFeature: action.payload,
            };
        }
        case FETCH_ALL_FEATURE_SUCCESS: {
            return {
                ...state,
                loader: false,
                allFeature: action.payload,
                featureList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addFeatureState: false,
                editFeatureState: false,
            };
        }
        case SHOW_FEATURE_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false,
            };
        }
        case ON_FEATURE_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedDependencies = 0;
            const dependencyList = state.dependencyList.map((dependency) => {
                if (dependency.selected) {
                    selectedDependencies++;
                }
                if (dependency.id === action.payload.id) {
                    if (dependency.selected) {
                        selectedDependencies++;
                    }
                    return action.payload;
                } else {
                    return dependency;
                }
            });
            return {
                ...state,
                INIT_STATE,
                selectedDependencies,
                dependencyList,
            };
        }
        case ON_ADD_FEATURE: {
            return { ...state, addFeatureState: true, editFeatureState: false };
        }
        case ON_EDIT_FEATURE: {
            return { ...state, addFeatureState: false, editFeatureState: true };
        }
        case ON_FEATURE_CLOSE: {
            return { ...state, addFeatureState: false, editFeatureState: false };
        }
        case ON_FILTER_FEATURE_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let featureList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    featureList = state.allFeature;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    featureList = state.allFeature.filter((dependency) => dependency.starred);
                    break;
                }
            }
            return {
                ...state,
                selectedSectionId,
                filterOption,
                featureList,
                drawerState: false,
            };
        }
        case ON_SAVE_FEATURE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                featureList: addOrUpdateEntry(state.featureList, action.payload),
                allFeature: addOrUpdateEntry(state.allFeature, action.payload),
                selectedFeature: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_FEATURE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allFeature: state.allFeature.filter((dependency) => dependency.id !== action.payload),
                featureList: state.allFeature.filter((dependency) => dependency.id !== action.payload),
                selectedFeature: null,
            };
        }
        case ON_FILTER_SELECTED_FEATURE: {
            const features = state.allFeature.filter((dependency) => !dependency.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                featureList: features,
                selectedFeatures: 0,
            };
        }
        case FILTER_FEATURE: {
            const { filterOption } = state;
            let featureList = [];
            if (action.payload === '') {
                featureList = state.allFeature;
            } else {
                const filterFeature = state.allFeature.filter((dependency) => dependency.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1);
                if (filterOption === ALL_FILTER) {
                    featureList = filterFeature;
                } else if (filterOption === STARRED_FILTER) {
                    featureList = filterFeature.filter((dependency) => dependency.starred);
                }
            }
            return { ...state, featureList: featureList };
        }
        case GET_ALL_FEATURE: {
            let featureList = state.allFeature.map((dependency) =>
                dependency
                    ? {
                          ...dependency,
                          selected: true,
                      }
                    : dependency
            );
            return {
                ...state,
                selectedFeatures: featureList.length,
                allFeature: featureList,
                featureList: featureList,
            };
        }
        case GET_UNSELECTED_ALL_FEATURE: {
            let featureList = state.allFeature.map((dependency) =>
                dependency
                    ? {
                          ...dependency,
                          selected: false,
                      }
                    : dependency
            );
            return {
                ...state,
                selectedFeatures: 0,
                allFeature: featureList,
                featureList: featureList,
            };
        }
        case ON_ALL_FEATURE_SELECT: {
            const selectAll = state.selectedFeatures < state.featureList.length;
            let selectedFeatures = 0;
            let featureList = [];
            if (selectAll) {
                featureList = state.allFeature.map((dependency) =>
                    dependency
                        ? {
                              ...dependency,
                              selected: true,
                          }
                        : dependency
                );
                selectedFeatures = featureList.length;
            } else {
                featureList = state.allFeature.map((dependency) =>
                    dependency
                        ? {
                              ...dependency,
                              selected: true,
                          }
                        : dependency
                );
                selectedFeatures = 0;
            }
            return {
                ...state,
                selectedFeatures: selectedFeatures,
                allFeature: featureList,
                featureList: featureList,
            };
        }
        case UPDATE_SEARCH_FEATURE: {
            return { ...state, searchFeature: action.payload };
        }
        case HANDLE_FEATURE_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_FEATURE_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_FEATURE_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_FEATURE_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/feature.js